import React from 'react';
import { Card } from '@/components/ui/card';
import { Calendar, Lock, Repeat } from 'lucide-react';

export default function ModeToggle({ mode, setMode }) {
  const isManual = mode === 'manual_booking';
  const isBlock = mode === 'block_court';
  const isSeries = mode === 'series';

  const baseBtn = 'inline-flex items-center gap-2 px-4 py-2 rounded-full border text-sm font-semibold transition-colors';

  return (
    <Card className="p-4 mb-6">
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => setMode('manual_booking')}
          data-testid="mode-manual"
          className={`${baseBtn} ${
            isManual
              ? 'bg-emerald-600 text-white border-emerald-600'
              : 'bg-emerald-50 text-emerald-800 border-emerald-200 hover:bg-emerald-100'
          }`}
        >
          <Calendar className="w-4 h-4" />
          Manual Booking
        </button>
        <button
          type="button"
          onClick={() => setMode('series')}
          data-testid="mode-series"
          className={`${baseBtn} ${
            isSeries
              ? 'bg-emerald-700 text-white border-emerald-700'
              : 'bg-emerald-50 text-emerald-800 border-emerald-200 hover:bg-emerald-100'
          }`}
        >
          <Repeat className="w-4 h-4" />
          Recurring Series
        </button>
        <button
          type="button"
          onClick={() => setMode('block_court')}
          data-testid="mode-block"
          className={`${baseBtn} ${
            isBlock
              ? 'bg-slate-800 text-white border-slate-800'
              : 'bg-slate-50 text-slate-700 border-slate-200 hover:bg-slate-100'
          }`}
        >
          <Lock className="w-4 h-4" />
          Block Court
        </button>
      </div>
      <p className="text-xs text-muted-foreground mt-2">
        {isManual && "Create a confirmed booking on a customer's behalf. Cash, bank transfer, or complimentary."}
        {isSeries && 'Create a weekly or biweekly recurring series. Cash, complimentary, or pay later (hold). Conflicts skipped automatically.'}
        {isBlock && 'Reserve courts internally for maintenance, tournaments, or private events. No customer, no payment.'}
      </p>
    </Card>
  );
}
